exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aling-center[data-v-7291af4e]{align-self:center}", ""]);

// exports
